export type OverlayRouteId =
  | "privacy"
  | "terms"
  | "methodology"
  | "data-deletion"
  | "know-more"
  | "get-app"
  | "start"
  | "start-done";

export type InformationRouteId = Extract<
  OverlayRouteId,
  | "privacy"
  | "terms"
  | "methodology"
  | "data-deletion"
  | "get-app"
  | "start"
  | "start-done"
>;

export const INFORMATION_ROUTES: InformationRouteId[] = [
  "privacy",
  "terms",
  "methodology",
  "data-deletion",
  "get-app",
  "start",
  "start-done",
];

export const OVERLAY_ROUTE_PATHS: Record<OverlayRouteId, string> = {
  privacy: "/privacy/",
  terms: "/terms/",
  methodology: "/methodology/",
  "data-deletion": "/data-deletion/",
  "know-more": "/know-more/",
  "get-app": "/get/",
  start: "/start/",
  "start-done": "/start/done/",
};

export const OVERLAY_ROUTE_TITLES: Record<OverlayRouteId, string> = {
  privacy: "Privacy Policy - Mana World",
  terms: "Terms and Conditions - Mana World",
  methodology: "Methodology - Mana World",
  "data-deletion": "Account and Data Deletion - Mana World",
  "know-more": "Mana World — Know What's In Your World",
  "get-app": "Get the Mana app",
  start: "Start your free trial - Mana",
  "start-done": "You're in - Mana",
};

export const DEFAULT_DOCUMENT_TITLE = "Mana World — Know What's In Your World";

export function normalizePathname(pathname: string): string {
  if (pathname === "/" || pathname === "") return "/";
  return pathname.replace(/\/+$/, "");
}

export function pathnameToOverlayRoute(
  pathname: string,
): OverlayRouteId | null {
  switch (normalizePathname(pathname)) {
    case "/about":
    case "/know-more":
      return "know-more";
    case "/privacy":
      return "privacy";
    case "/terms":
      return "terms";
    case "/methodology":
      return "methodology";
    case "/data-deletion":
      return "data-deletion";
    case "/get":
    case "/get-app":
    case "/download":
      return "get-app";
    case "/start":
      return "start";
    case "/start/done":
      return "start-done";
    default:
      return null;
  }
}

export function overlayRouteToPath(route: OverlayRouteId): string {
  return OVERLAY_ROUTE_PATHS[route];
}

export function isInformationRoute(
  route: OverlayRouteId | null,
): route is InformationRouteId {
  return (
    route !== null && INFORMATION_ROUTES.includes(route as InformationRouteId)
  );
}

export const FOOTER_OVERLAY_ROUTES: OverlayRouteId[] = [
  "know-more",
  "privacy",
  "terms",
  "methodology",
];

export const FOOTER_ROUTE_LABELS: Record<OverlayRouteId, string> = {
  privacy: "Privacy",
  terms: "Terms",
  methodology: "Methodology",
  "data-deletion": "Data Deletion",
  "know-more": "About",
  "get-app": "Get the App",
  start: "Start",
  "start-done": "Start",
};
